import { parseAmountField } from "@/lib/amount";

/**
 * Черновик поля «минимальный размер» фильтра экрана (design.md
 * stage8-amount-shorthand, Д4). Поле держит набранный текст, а в фильтр
 * попадает только прочитанное значение. `Number` здесь допустим: фильтр
 * показа хранит `number`, это не запись в демон.
 */
export interface MinUsdDraft {
  text: string;
  /** Текст нечитаем: под полем подсказка, фильтр прежний. */
  invalid: boolean;
}

/**
 * Показ значения фильтра в поле: разряды через ru-RU (U+00A0, поле их снимает),
 * дробь точкой, без округления — то, что поле само читает обратно.
 */
export function minUsdText(minUsd: number | null): string {
  if (minUsd === null) {
    return "";
  }
  return minUsd.toLocaleString("ru-RU", { maximumFractionDigits: 20 }).replace(",", ".");
}

/**
 * Согласует поле с размером фильтра после смены `filters.minUsd` (зовётся
 * только на смену). Набранный текст, который читается в текущий размер,
 * остаётся как есть — так «1м» не превращается в «1 000 000» посреди набора.
 * Всё прочее (крестик на фишке, «Сбросить всё», нечитаемый черновик, который
 * размер не менял) — поле показывает размер заново.
 */
export function reconcileMinUsdDraft(draft: MinUsdDraft, minUsd: number | null): MinUsdDraft {
  const read = editMinUsdDraft(draft.text).apply;
  if (read !== null && read.minUsd === minUsd) {
    return draft;
  }
  return { text: minUsdText(minUsd), invalid: false };
}

/** Что делать на изменение текста: новый черновик и, если читается, значение для фильтра. */
export function editMinUsdDraft(text: string): {
  draft: MinUsdDraft;
  apply: { minUsd: number | null } | null;
} {
  const parsed = parseAmountField(text);
  if (!parsed.ok) {
    return { draft: { text, invalid: true }, apply: null };
  }
  return {
    draft: { text, invalid: false },
    apply: { minUsd: parsed.value === null ? null : Number(parsed.value) },
  };
}
